import apiAxios from '@/services/axiosConfig';
import type { ValidateKeyRequest, ValidateKeyResponse } from '@/types/api';

async function validateKey(data: ValidateKeyRequest): Promise<ValidateKeyResponse> {
  const response = await apiAxios.post<ValidateKeyResponse>('/api/v1/mt/connections/validate', data);
  return response.data;
}

export default validateKey;
